module.exports = __webpack_public_path__ + "img/goods1_bg.41ca3905.png";